import { studentApi } from './studentApi';
import { API_ENDPOINTS } from './api';

export interface Country {
  id: number;
  name: string;
  code?: string;
}

export interface Council {
  id: number;
  name: string;
  code?: string;
  country: string;
  state: string;
}

export interface School {
  id: number;
  name: string;
  councilId: number;
  councilName?: string;
  address?: string;
}

export interface Class {
  id: number;
  name: string;
  schoolId: number;
  schoolName?: string;
  courseId?: number;
  academicYear: string;
  learningYear?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data?: T;
}

class LocationService {
  async getCountries(): Promise<Country[]> {
    try {
      const response = await studentApi.get<ApiResponse<Country[]>>(API_ENDPOINTS.LOCATIONS.COUNTRIES);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching countries:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch countries');
    }
  }

  async getCouncils(countryId?: number): Promise<Council[]> {
    try {
      let url = API_ENDPOINTS.LOCATIONS.COUNCILS;
      if (countryId) {
        url += `?countryId=${countryId}`;
      }
      const response = await studentApi.get<ApiResponse<Council[]>>(url);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching councils:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch councils');
    }
  }

  async getSchoolsByCouncil(councilId: number): Promise<School[]> {
    try {
      const response = await studentApi.get<ApiResponse<School[]>>(
        `${API_ENDPOINTS.LOCATIONS.SCHOOLS}?councilId=${councilId}`
      );
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching schools:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch schools');
    }
  }

  async getClassesBySchool(schoolId: number, courseId?: number): Promise<Class[]> {
    try {
      let url = `${API_ENDPOINTS.LOCATIONS.CLASSES}?schoolId=${schoolId}`;
      if (courseId) {
        url += `&courseId=${courseId}`;
      }
      const response = await studentApi.get<ApiResponse<Class[]>>(url);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching classes:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch classes');
    }
  }
}

export const locationService = new LocationService();
export default locationService;

